import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkboxes, FileInput, RadioButtons, TabPanel, Dropdown } from '../../../FlowConfigurationInputs';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @param       action
 * @param       showAlert -  show alert
 * @param       setOpenVariable
 * @param       variables
 * @Returns     Component
 * @Author      Onur DOGUCU
 */
function ReadDocument({ action, showAlert, setOpenVariable, variables }) {
    const { t } = useTranslation();
    const [value, setValue] = useState(0);
    const label = 'CONTENT.CONFIGURATION-FORM.WORD.READ-DOCUMENT.';
    const options = {
        fileInput: {
            checkExtension: (ext) => {
                if (ext !== 'doc' && ext !== 'docx') {
                    showAlert(t(label + 'UPLOAD_WORD_ONLY'));
                    return false;
                }
                return true;
            },
            fileType: 'application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        }
    }
    useEffect(() => {
        if (!action.fields.fileType) {
            action.fields.fileType = { value: "FILE" };
        } else {
            if (action.fields.fileType.value === "FILE") {
                setValue(0);
            } else {
                setValue(1)
            }
        }
    }, [action, variables])

    function handleChangeTabs(newValue) {
        if (newValue === 1) {
            action.fields.filePath.type = 'TEXT';
            action.fields.fileType.value = 'TEXT';
            action.fields.filePath.backup = { value: action.fields.filePath.value };
            action.fields.filePath.value = "";
            if (action.fields.filePath.backupText?.value) {
                action.fields.filePath.value = action.fields.filePath.backupText.value;
            }
        } else {
            action.fields.filePath.type = 'FILE';
            action.fields.fileType.value = 'FILE';
            action.fields.filePath.backupText = { value: action.fields.filePath.value }
            delete action.fields.filePath.value
            if (action.fields.filePath.backup?.value) {
                action.fields.filePath.value = action.fields.filePath.backup.value;
            }
        }
        setValue(newValue);
    }

    return (
        <div>
            <div className="form-element">
                {t(label + 'FILE-PATH')}
                <div className="condition-tabs" style={{ marginBottom: 5 }}>
                    <button
                        className={value === 0 ? 'condition-active' : ''}
                        onClick={() => handleChangeTabs(0)}>
                        {t(label + 'SELECT-FILE')}
                    </button>
                    <button
                        className={value === 1 ? 'condition-active' : ''}
                        onClick={() => handleChangeTabs(1)}>
                        {t(label + 'CUSTOM-STRING')}
                    </button>
                </div>
                <TabPanel value={value} index={0}>
                    <FileInput action={action} inputName="filePath" options={options.fileInput} isRequired
                        isSize={true} />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <TextInput action={action} inputName="filePath" isRequired={value === 1} setOpenVariable={setOpenVariable}
                        variables={variables} />
                </TabPanel>
            </div>
            <div className="form-element">
                {t(label + 'ASSIGN')}
                <VariablePicker action={action} inputName="set" variables={variables} setOpenVariable={setOpenVariable}
                    filter="array" isRequired />
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'array' })}</em></small>
            </div>
        </div>
    )
}

export default ReadDocument;
